import password from './password/index';
import con from '../../../connection';
var path = '/profiles';
var profiles = function (url) { return function () { return ({
    password: password("" + url + path),
    post: function (param) { return con.post("" + url + path, param); },
}); }; };
export default profiles;
